import { useRef, useState, useEffect } from 'react';

const AudioControl = () => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(true);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.play().catch(() => {});
    }
  }, []);

  const toggleAudio = e => {
    e?.preventDefault();
    if (!audioRef?.current) return;
    setPlaying(prev => !prev);
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();
    if (audioRef.current.paused) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  };

  return (
    <>
      <audio ref={audioRef} autoPlay loop>
        <source src={'/assets/snowman.mp3'} type='audio/mpeg' />
        <track kind='captions' srcLang='en' label='English captions' />
        Your browser does not support the audio element.
      </audio>
      <div
        role='button'
        tabIndex={0}
        onClick={toggleAudio}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            toggleAudio(e);
          }
        }}
        style={{
          position: 'fixed',
          display: 'flex',
          right: '10px',
          top: '12px',
          zIndex: 9999
        }}
        aria-label='Toggle audio'
      >
        <img
          src={playing ? '/assets/pause.png' : '/assets/play.png'}
          alt='Toggle audio'
          width={40}
        />
      </div>
    </>
  );
};

export default AudioControl;
